export const localStorageKeys = {
  AUTHORIZATION: 'authorization',
  USER: 'user',
}
